import React from 'react';

import Button from 'common/layout/Button';
import SimplePage from 'common/pages/SimplePage';

const ErrorRefreshPage = () => {
  const refresh = _ => {
    window.location.reload(true);
  };

  // Do not translate message as it's not in intl provider.
  return (
    <SimplePage>
      <h2>Oups !</h2>
      <div>Something’s gone wrong...</div>
      <div>Please click refresh button to reload the page</div>
      <div>
        <Button
          className="button"
          buttonType="primary"
          onClick={refresh}
          analytics={{ category: 'Error', action: 'Error refresh page' }}
        >
          Refresh
        </Button>
      </div>
    </SimplePage>
  );
};

export default ErrorRefreshPage;
